<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import {onMounted} from 'vue'

import { useEnsureCurrentUser } from '@/composables/useEnsureCurrentUser'
import { useConfigurationStore } from '@/stores/configurationStore'

const { t } = useI18n()
const { isInitialized } = useEnsureCurrentUser()
const configurationStore = useConfigurationStore()

onMounted(async () => {
  await configurationStore.getConfigurationConfig()
})
</script>

<template>
  <div
    v-if="!isInitialized"
    class="bg-background flex h-dvh flex-col items-center justify-center gap-3"
  >
    <div
      class="border-muted-foreground/30 border-t-muted-foreground/70 h-8 w-8 animate-spin rounded-full border-2"
    />
    <span class="text-muted-foreground/70 animate-pulse text-sm">
      {{ t('common.loading') }}
    </span>
  </div>
  <RouterView v-else />
</template>
